import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=fbd5ec7a&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbd5ec7a')) {
      api.createRecord('fbd5ec7a', component.options)
    } else {
      api.reload('fbd5ec7a', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=fbd5ec7a&", function () {
      api.rerender('fbd5ec7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MMC5XdlihNg5/JS/videoIframe.vue"
export default component.exports